import { Settings, Globe, Bell, Palette, Shield } from "lucide-react";

const Toggle = ({ on = true }) => (
  <div className={`w-11 h-6 rounded-full relative transition-colors ${on ? "bg-[#F0651E]" : "bg-slate-300 dark:bg-slate-600"}`}>
    <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full transition-all ${on ? "right-0.5" : "left-0.5"}`} />
  </div>
);

export default function SiteAyarlari() {
  return (
    <div className="space-y-5 max-w-3xl" data-testid="page-site-ayarlari">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
          <Settings className="text-[#F0651E]" size={22} />
        </div>
        <div>
          <h1 className="text-xl font-extrabold">Site Ayarları</h1>
          <p className="text-xs text-slate-500">Genel sistem yapılandırması</p>
        </div>
      </div>

      <div className="bg-white dark:bg-[#151824] rounded-2xl p-6 shadow-sm border border-slate-100 dark:border-slate-800 space-y-5">
        <div className="flex items-center gap-2 font-bold"><Globe size={18} className="text-[#F0651E]" /> Genel</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { l: "Site Adı", v: "Sezar" },
            { l: "Alan Adı", v: "littlecaesarspizzas.com" },
            { l: "Para Birimi", v: "TRY (₺)" },
            { l: "Saat Dilimi", v: "GMT+3 (İstanbul)" },
          ].map((f) => (
            <div key={f.l}>
              <label className="text-xs font-semibold text-slate-500">{f.l}</label>
              <input defaultValue={f.v} className="w-full mt-1 rounded-xl border border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 px-4 py-2.5 text-sm font-medium" />
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white dark:bg-[#151824] rounded-2xl p-6 shadow-sm border border-slate-100 dark:border-slate-800 space-y-4">
        <div className="flex items-center gap-2 font-bold"><Shield size={18} className="text-[#F0651E]" /> Güvenlik & Bildirim</div>
        {[
          { i: Shield, t: "İki Adımlı Doğrulama", d: "Yönetici girişlerinde zorunlu", on: true },
          { i: Bell, t: "E-posta Bildirimleri", d: "Büyük işlemlerde uyarı gönder", on: true },
          { i: Palette, t: "Bakım Modu", d: "Siteyi geçici olarak kapat", on: false },
        ].map((r) => (
          <div key={r.t} className="flex items-center justify-between rounded-xl border border-slate-200 dark:border-slate-700 p-4">
            <div className="flex items-center gap-3">
              <r.i size={18} className="text-slate-400" />
              <div>
                <div className="font-semibold text-sm">{r.t}</div>
                <div className="text-xs text-slate-500">{r.d}</div>
              </div>
            </div>
            <Toggle on={r.on} />
          </div>
        ))}
        <button className="rounded-xl bg-[#F0651E] px-5 py-2.5 text-sm font-bold text-white hover:bg-[#d9560f]">Ayarları Kaydet</button>
      </div>
    </div>
  );
}
